(function () {

  DisableItemController.$inject = ["$q", "$scope", "$modal", "PATH"];
  app.controller('DisableItemController', DisableItemController);

  function DisableItemController($q, $scope, $modal, PATH) {
    $scope.isDeleteInProgress = { result: false };

    $scope.deletionModal = $modal({
      scope: $scope,
      show: false,
      templateUrl: PATH.components + 'disableItemDirective/modal.disableitem.tpl.html'
    });

    $scope.showDeleteModal = function () {
      $scope.message = $scope.message || 'Are you sure you want to disable "' + $scope.caption + '"?';
      $scope.deletionModal.show();
    };

    $scope.delete = function () {
      $scope.isDeleteInProgress.result = true;
      return $q.when($scope.disableAction())
        .then(function () {
          $scope.deletionModal.hide();
        })
        .finally(function () {
          $scope.isDeleteInProgress .result= false;
        });
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/disableItemDirective/disableItemController.js